import { useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import chantierReducer from './slices/chantierSlice';
import toastReducer from './slices/toastSlice';
import tierReducer from './slices/tierSlice';
import userReducer from './slices/userSlice';
import enginReducer from './slices/enginSlice';
import citerneReducer from './slices/citerneSlice';
import pompisteReducer from './slices/pompisteSlice';
import roleReducer from './slices/roleSlice';
import familleReducer from './slices/familleSlice';
import natureReducer from './slices/natureSlice';
import affectationReducer from './slices/affectationSlice';
import enginAffectationReducer from './slices/enginAffectationSlice';
import jaugeReducer from './slices/jaugeSlice';
import movementReducer from './slices/movementSlice';
import chartReducer from './slices/chartSlice';
import configReducer from './slices/configSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    config: configReducer,
    chantier: chantierReducer,
    toast: toastReducer,
    tier: tierReducer,
    user: userReducer,
    engin: enginReducer,
    citerne: citerneReducer,
    pompiste: pompisteReducer,
    role: roleReducer,
    famille: familleReducer,
    nature: natureReducer,
    affectation: affectationReducer,
    enginAffectation: enginAffectationReducer,
    jauge: jaugeReducer,
    movement: movementReducer,
    chart: chartReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector;
